import { render, staticRenderFns } from "./SmartTableTrials.vue?vue&type=template&id=cb53e8fe"
import script from "./SmartTableTrials.js?vue&type=script&lang=js&external"
export * from "./SmartTableTrials.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports